import type { UseFormReturn } from 'react-hook-form';
import type { CarFormData } from '../types/car';
import { FormField } from './FormField';
import { CAR_BRANDS, COLORS } from '@moshina-bozor/shared';

interface Props {
  form: UseFormReturn<CarFormData>;
}

export function StepBasicInfo({ form }: Props) {
  const {
    register,
    formState: { errors },
  } = form;

  return (
    <div className="form-step">
      <h2>Asosiy ma'lumotlar</h2>

      <FormField label="Marka" required error={errors.brand}>
        <select {...register('brand')} className={errors.brand ? 'error' : ''}>
          <option value="">Tanlang...</option>
          {CAR_BRANDS.map((brand) => (
            <option key={brand.value} value={brand.value}>
              {brand.label}
            </option>
          ))}
        </select>
      </FormField>

      <FormField label="Model" required error={errors.model}>
        <input
          {...register('model')}
          type="text"
          placeholder="Masalan: Cobalt, Spark"
          className={errors.model ? 'error' : ''}
        />
      </FormField>

      <div className="form-row">
        <FormField label="Yili" required error={errors.year}>
          <input
            {...register('year', { valueAsNumber: true })}
            type="number"
            placeholder="2020"
            min={1990}
            max={new Date().getFullYear() + 1}
            className={errors.year ? 'error' : ''}
          />
        </FormField>

        <FormField label="Rang" required error={errors.color}>
          <select {...register('color')} className={errors.color ? 'error' : ''}>
            <option value="">Tanlang...</option>
            {COLORS.map((color) => (
              <option key={color.value} value={color.value}>
                {color.label}
              </option>
            ))}
          </select>
        </FormField>
      </div>
    </div>
  );
}
